export enum ComponentType {
  CUBICLE = 'cubicle',
  TRANSFORMER = 'transformer',
  ACCESSORY = 'accessory',
  OPTION = 'option',
  PACKING = 'packing',
  SERVICE = 'service'
}
